import { Component, EventEmitter,  Inject, Input, Output, OnInit} from 'ng-metadata/core';
import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {SmoothScrollUtil} from "../../../nddUtils/smoothScrollUtil.service";
import {CollectionDiscoveryService} from "../../../collectionDiscovery/collectionDiscovery.service";
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {ChangeLangService} from "../../../infra/lang/changeLang.service";
import {DirectLinkService} from "../../directLink/directLink.service";
import {TemplateUtil} from "../../../nddUtils/templateUtil.service";
import {MappingTablesCache} from "../../../mappingTablesCache/mappingTablesCache.service";

let he= require('he');
const get= require('lodash/get');

const emptyArray = [];

@Component({
    "selector": "prm-search-result-availability-line",
    templateUrl: 'components/search/searchResult/searchResultAvailability/searchResultAvailabilityLine.html'
})

export class PrmSearchResultAvailabilityLine implements OnInit{


    private availabilityLineIcons: Object[];
    private _organization:string;
    private _libraryCode:string;
    private _subLocation:string;
    private _callNumber:string;
    private locationReady:boolean;
    private showTimer = false;
    private isCollectionDiscoveryCollection: boolean;
    private COLLECTION_DISCOVERY_STATE = STATE_NAMES.COLLECTION_DISCOVERY;
    private _collectionStateParams: Object;

    private originalFirstAvailability:string;
    private isReversed:boolean = false;

    @Input() private isOverlayFullView:boolean;
    @Input() private result: any;
    @Input() private isFullView: boolean;
    @Input() private collectionDiscoveryData: { type; collectionId; institution };
    @Input() private isRefEntry: any;
    @Input() public displayMode: string;
    @Output() openFullDisplayWithGetit1 = new EventEmitter<Object>();
    @Output() openFullDisplayWithNgrs = new EventEmitter<Object>();

    constructor(@Inject('availabilityLineIcons') availabilityLineIcons,
                private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private primolyticsService: PrimolyticsService,
                @Inject('$element') private $element: ng.IAugmentedJQuery,
                @Inject('$translate')  private $translate:ng.translate.ITranslateService,
                private configurationUtil: ConfigurationUtil,
                private collectionDiscoveryService: CollectionDiscoveryService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private changeLangService: ChangeLangService,
                private directLinkService: DirectLinkService,
                private templateUtil: TemplateUtil,
                private mappingTablesCache : MappingTablesCache) {
        this.availabilityLineIcons = availabilityLineIcons;
        this.locationReady = false;
        if(this.configurationUtil.isSuprima()){
            this.$timeout(()=>{
                this.showTimer= true;
            },2000);
        }else{
            this.showTimer= true;
        }

    }


    ngOnInit() {
        if (this.collectionDiscoveryData){
            this.isCollectionDiscoveryCollection=  this.collectionDiscoveryData.type === 'COLLECTION' || this.collectionDiscoveryData.type === 'TOPCOLLECTION';
            this._collectionStateParams= {collectionId: this.collectionDiscoveryData.collectionId, inst: this.collectionDiscoveryData.institution,
                vid: this.$stateParams['vid'], lang: this.$stateParams['lang']};
        }

        let availabilityArray = get(this.result , 'delivery.availability') || emptyArray;
        this.originalFirstAvailability = availabilityArray[0];

    }


    private scrollToElementId(scrollId){
        // let eID = "getit_link1_0";
        let eID= scrollId;
        let elm = document.getElementById(eID);
        if(!elm){
            eID = "links";
            elm = document.getElementById(eID);
        }
        elm.classList.add("section-focused");

        this.$timeout(()=>{
            elm.classList.remove("section-focused");
        }, 500);
        if (this.isOverlayFullView){
            this.smoothScrollUtil.scrollTo(eID,'','sticky-scroll');
        }
        else{
            this.smoothScrollUtil.scrollTo(eID,'','');
        }
    }

    public isEmailMode() {
        return this.displayMode === 'email';
    }

    public initLocation(){
        if(this.result.delivery.bestlocation!= undefined){
            this.result.delivery.bestlocation.pendingRender = false;
            this.locationReady = true;
            this.initOrg();
            this.initLibraryCode();
            this.initSubLocation()
        }
    }

    public availabilityLinks(){
        if (this.result && this.result.delivery && this.result.delivery.availabilityLinks) {
            return this.result.delivery.availabilityLinks;
        }
        return emptyArray;
    }

    public availabilityLinksUrl(){
        if (this.result && this.result.delivery && this.result.delivery.availabilityLinksUrl) {
            return this.result.delivery.availabilityLinksUrl;
        }
        return emptyArray;
    }

    public delCategories(){
        return get(this.result, 'delivery.deliveryCategory') || emptyArray;
    }

    get displayedAvailability() {

        if (this.result && this.result.delivery) {
            if (this.result.delivery.availability && this.result.delivery.availability.length > 1 && this.isPhysical(1,this.result.delivery.availability[1])) {

                this.result.delivery.availability.reverse();
                if (this.result.delivery.availabilityLinks) this.result.delivery.availabilityLinks.reverse();
                if (this.result.delivery.availabilityLinksUrl) this.result.delivery.availabilityLinksUrl.reverse();
                if (this.result.delivery.deliveryCategory) this.result.delivery.deliveryCategory.reverse();
                if (this.result.delivery.serviceMode) this.result.delivery.serviceMode.reverse();

                this.isReversed = true;
            }

            /*  PRM-38977 NUI: Getit & Viewit lables switch places for records with restricted delivery online+physical item
                deliveryCategory was reversed and availability was reversed back by RTA ???
            */
            if (this.isReversed &&
                get(this.result, 'delivery.availability[0]') === this.originalFirstAvailability) {
                this.result.delivery.availability.reverse();
            }
        }

        return get(this.result, 'delivery.availability') || emptyArray;

    }


    set libraryCode(value: string) {
        this._libraryCode = value;
    }
    set subLocation(value: string) {
        this._subLocation = value;
    }
    set organization(value: string) {
        this._organization = value;
    }
    set callNumber(value: string) {
        this._callNumber = value;
    }



    private getTranslatedLine(status){

        let bestLocation = this.result.delivery.bestlocation || {};
        let callNumberJson= {};
        let callNumber = bestLocation.callNumber || '';
        let organization = bestLocation.organization || '';
        let libraryCode = bestLocation.libraryCode || '';
        let subLocation = bestLocation.subLocation || '';


        let placeHolders = {
            idx_0: this.$translate.instant(organization),
            idx_1: this.$translate.instant(libraryCode),
            idx_2: this.$translate.instant(subLocation),
            idx_3: bestLocation.callNumber,
            idx_4: this.$translate.instant(this.result.delivery.formatedDueDate || '')
        };

        if(this.result.delivery.formatedDueDate){
            status=status+".tooltip.duedate";
        }
        let label = this.$translate.instant(status, placeHolders);
        label= he.decode(label);
        return label;

    }

    getPlaceHolders() {
        if(!this.locationReady || get(this.result, 'delivery.bestlocation.pendingRender')) {
            this.initLocation()
        }
        let callNumber = this.callNumber  || "";
        let organization = this.organization || "";
        let libraryCode = this.libraryCode  || "";
        let subLocation = this.subLocation  || "";
        let libraryHtml = `<span class="best-location-library-code locations-link">${libraryCode}</span>`;
        let sublocationHtml = `<span class="best-location-sub-location locations-link">${subLocation}</span>`;
        let callnumberHtml = `<span class="best-location-delivery locations-link">${callNumber}</span>`;

        let placeHolders = {
            idx_0: `<span class="best-location-organization locations-link">${organization}</span>`,
            idx_1: `${libraryHtml} ${sublocationHtml} ${callnumberHtml}`,
            idx_2: `<span class="best-location-due-date">${this.result.delivery.formatedDueDate}</span>`,
        };

        return placeHolders;

    }

    public initOrg(){
        let bestLocation = this.result.delivery.bestlocation || {};
        let org = bestLocation.organization || '';
        this.$translate(org,[],'', org).then(translation=> {this.organization = translation});
    }

    get organization(){
        return this._organization;
    }

    public initLibraryCode(){
        let bestLocation = this.result.delivery.bestlocation || {};
        let lib =  bestLocation.libraryCode || '';
        let instCode = bestLocation.organization;
        if(!this.configurationUtil.isSuprima() && lib){
            this.$translate(instCode+'.library.'+lib,[],'', this.$translate.instant(lib)).then(translation=> {this.libraryCode = translation});
        }else{
            this.$translate(lib,[],'', lib).then(translation=> {this.libraryCode = translation});
        }


    }


    get libraryCode(){
        return this._libraryCode;
    }


    public initSubLocation(){
        let bestLocation = this.result.delivery.bestlocation || {};
        let subLoc =  bestLocation.subLocation || '';
        let instCode = bestLocation.organization;
        if(!this.configurationUtil.isSuprima() && subLoc){
            this.subLocation = subLoc;
            /* if value contains any dot (.), it means that no needed to translate it */
            if (subLoc.indexOf('.') < 0 ) {
                this.$translate(instCode+'.collection.'+subLoc,[],'', this.$translate.instant(subLoc)).then(translation=> {this.subLocation = translation});
            }
        }else{
            this.$translate(subLoc,[],'', subLoc).then(translation=> {this.subLocation = translation});
        }


    }

    get subLocation(){
        return this._subLocation
    }

    get callNumber(){
        let bestLocation = this.result.delivery.bestlocation || {};
        let callNumber = bestLocation.callNumber || '';
        if (callNumber.length > 0 && this.configurationUtil.isSuprima()) {
            return `<span class="availability-line-parenthesis">(</span>` + callNumber + `<span class="availability-line-parenthesis">)</span>`;
        }
        return callNumber;
    }

    showPhysicalItemTextCodes() {
        return this.result.delivery.physicalItemTextCodes;
    }

    showDisplayOtherLocations() {
        return this.result.delivery.feDisplayOtherLocations;
    }

    showDisplayLocation() {
         return !this.configurationUtil.isSuprima() && this.result.delivery.displayLocation;
    }

    handleAvailability(index, $event) {
        //console.log(this.isFullView);
        //if (true) {
        this.handleAvailabilityLine(index, $event);
        //}
    }

    handleDueDate(status){
        if(this.result.delivery.formatedDueDate){
            status=status+".duedate";
        }
        return this.handleNgrs(status);
    }

    handleNgrs(status){
        if(this.isNgrs()){
            if(status === 'unavailable' || status === 'not_available'){
                return "ngrs." + status;
            }
        }
        return status;
    }

    @beacon({'p':'brief', 'op':'availabilityStatement','item':'result'})
    handleAvailabilityLine(index, $event) {
        if(this.doPrimoVEDirectLink(index) && !this.isRefEntry){
            this.getAndOpenPrimoVEDirectLink();
        }
        else if (this.isDirectLink(index)) {
            let avalinkUrl =  this.availabilityLinksUrl()[index];
            window.open(avalinkUrl,'_blank');
        }
        else if(this.isNgrs()){
            //throw event that will trigger full view with focus on 'get it from other location' tab

            this.triggerFullViewOpenNgrs(index);
        }
        else {
            //throw event that will trigger full view with focus on 'getit1' tab
            this.triggerFullViewOpenGetIt1(index);
        }
        //for beacon only - new field in this.result
        this.result.beaconIsPhsical = this.isPhysical(index);
    }

    @beacon({ 'p': 'brief', 'op': 'linktoCollection' })
    public runCollectionDiscoveryBeacon() {}

    private doPrimoVEDirectLink(index) {
        return this.configurationUtil.isSuprima() &&
            this.mappingTablesCache.findByProperties('direct linking config', {target: 'enableDirectLinking'})[0].source1 === 'YES' &&
            !(this.isFullView || this.isOverlayFullView) &&
            this.isOnline(index, this.displayedAvailability[index]);
    }

    private getAndOpenPrimoVEDirectLink() {
        let popupWin = window.open('', '_blank');
        this.directLinkService.getDirectLinkURL(this.result).then((fullTextURL: string) => {
            if (fullTextURL) {
                popupWin.location = fullTextURL;
            }
            else {
                popupWin.location = this.templateUtil.getDeepLinkAbsPath(this.result);
            }
        }, (err) => {
            popupWin.location = this.templateUtil.getDeepLinkAbsPath(this.result);
        });
    }

    private triggerFullViewOpenGetIt1(index){
        //throw event that will trigger full view with focus on 'getit1' tab
        let getitIndex = 0;
        if (this.result.delivery.availability.length === 2) {
            getitIndex = 1 - index;
        }
        if(this.isFull()){
            return this.scrollToElementId('getit_link1_'+getitIndex);
        }
        let eventData = {index:'getit_link1_'+getitIndex, target: this.$element[0]};
        if (getSelection().toString().length > 0) {
            if (getSelection().empty) {
                getSelection().empty();
            } else if (getSelection().removeAllRanges) {
                getSelection().removeAllRanges();
            }
        }
        this.openFullDisplayWithGetit1.emit(eventData);
    }

    private triggerFullViewOpenNgrs(index){
        //throw event that will trigger full view with focus on 'ngrs' tab
        if (this.result.delivery.availability[0] === 'not_available' || this.result.delivery.availability[0] === 'unavailable'){
            if(this.isFull()){
                return this.scrollToElementId('ngrs');
            }
            let eventData = {index:'ngrs', target: this.$element[0]};
            this.openFullDisplayWithNgrs.emit(eventData);
        }
        else{
            this.triggerFullViewOpenGetIt1(index);
        }
    }



    isDirectLink(index) {
        if ((this.availabilityLinks().length > 0) && (this.availabilityLinks()[index] === 'directlink')) {
            if(this.configurationUtil.isSuprima() && !this.isRefEntry){
                return false;
            }
            return true;
        }
        return false;

    }


    isPhysical(index,availability) {
        let delCategories = this.delCategories();
        if ((delCategories[index] === 'Physical Item') || (delCategories[index] === 'Microform') ||
            (delCategories[index] === 'Alma-P') ||
            (delCategories[index] === 'Remote Search Resource' && availability === 'worldcat')) {
            return true;
        }
        return false;
    }

    isOnline(index,availability) {
        // console.log(availability +"   " + this.delCategories[index]);
        if (!this.isPhysical(index) && (!(this.delCategories()[index] === 'Remote Search Resource' && availability === 'worldcat'))) {
            return true;
        }
        return false;
    }

    isNgrs(){
        return window.appConfig['system-configuration'].ngrs_enabled;
    }


    isFull() {
        if (!this.isFullView || this.isFullView === undefined) {
            return false;
        }
        return true;
    }

    get collectionStateParams(){
        return this._collectionStateParams;
    }

    private showDedupOtherLocations () {

        if (get(this.result,'pnx.dedup') != undefined) {
            if (get(this.result,'pnx.display.availlibrary.length', 0) > 1) {
                return true;
            }
        }
        return false;
    }

    private switchToLtrString() {
        return this.changeLangService.direction == 'rtl';
    }

    getNgrsStyle(){
        let ngrsStyle = {};
        if(this.isNgrs()){
            ngrsStyle = { 'color': 'green'};
        }
        return ngrsStyle;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultAvailability/searchResultAvailabilityLine.directive.ts